import * as React from "react"
import { useIsMobile } from "./use-mobile"

export interface MobileDesktopChangeParams {
  wasMobile: boolean
  isMobile: boolean
}

/**
 * Runs a handler when the mobile/desktop breakpoint state changes.
 * The handler receives previous and current state, and runs only on transitions (not on initial mount).
 */
export function useOnMobileDesktopChange(handler: (params: MobileDesktopChangeParams) => void) {
  const isMobile = useIsMobile()
  const prevIsMobileRef = React.useRef<boolean | undefined>(undefined)

  React.useEffect(() => {
    const wasMobile = prevIsMobileRef.current
    prevIsMobileRef.current = isMobile

    if (wasMobile !== undefined && wasMobile !== isMobile) {
      handler({ wasMobile, isMobile })
    }
  }, [isMobile, handler])
}
